import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en.json'
import ro from './locales/ro.json'

Vue.use(VueI18n)
const allowdLanguages = ['ro', 'en'];

const locale = allowdLanguages.indexOf(navigator.language) != -1 ? navigator.language : 'en'
const messages = {
    ro: ro,
    en: en
}
const i18n = new VueI18n({
    locale,
    messages
})
export default i18n